<template>
  <div>
    <label v-for="opt in options" :key="opt.id" style="display:block;margin:4px 0;">
      <input type="checkbox"
             :value="opt.id"
             :checked="value.includes(opt.id)"
             @change="onItemChange($event, opt.id)">
      {{ opt.name }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxGroup',
  data () {
    return {}
  },
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, required: true }, // [{id,label}]
    selectAllLabel: { type: String, default: 'Alle' }
  },
  methods: {
    onItemChange (e, id) {
      const next = new Set(this.value)
      if (e.target.checked) {
        next.add(id)
      } else {
        next.delete(id)
      }
      this.$emit('input', Array.from(next))
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
